<div
  class="fixed inset-0 flex items-center justify-center bg-black/80 backdrop-blur-sm z-[9999] p-3"
>
  <div class="wallet-modal-shell w-full max-w-sm text-center">
    <!-- Close Button -->
    <button
      type="button"
      (click)="onClose()"
      class="wallet-modal-close absolute top-3 right-3"
      aria-label="Close"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>

    <!-- Icon -->
    <div class="flex justify-center mb-6">
      <div
        class="w-16 h-16 flex items-center justify-center rounded-full bg-[var(--modal-text-yellow)]/15 border border-[var(--modal-text-yellow)]/40 shadow-[0_0_22px_rgba(250,204,21,0.25)]"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-8 h-8 text-[var(--modal-text-yellow)]"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 9v2m0 4h.01M12 3a9 9 0 110 18 9 9 0 010-18z"
          />
        </svg>
      </div>
    </div>

    <!-- Title -->
    <h2 class="text-[var(--modal-text-yellow)] text-xl font-bold mb-3">
      {{ title }}
    </h2>

    <!-- Message -->
    <p class="text-[var(--modal-text-muted)] text-sm mb-8 leading-relaxed">
      {{ message }}
    </p>

    <!-- Button -->
    <button (click)="onAction()" class="wallet-btn-action w-full">
      {{ buttonText }}
    </button>
  </div>
</div>
